// client/src/components/admin/ResetPasswordModal.js
import React from 'react';
import { KeyRound } from "lucide-react";

function ResetPasswordModal({
  handleResetPassword,
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  setShowResetPasswordModal,
}) {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">
          <KeyRound size={20} className="inline mr-2" /> Reset Password
        </h3>

        <form onSubmit={handleResetPassword}>
          <div className="responsive-grid">
            <div className="form-group col-span-full">
              <label>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                className="input-field"
                minLength={8}
                placeholder="Enter new password"
              />
            </div>

            <div className="form-group col-span-full">
              <label>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="input-field"
                minLength={8}
                placeholder="Confirm new password"
              />
            </div>
          </div>

          <div className="button-group-center mt-6">
            <button type="submit" className="btn-primary">
              Reset Password
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => {
                setShowResetPasswordModal(false);
                setNewPassword("");
                setConfirmPassword("");
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordModal;